import state from './customersState'
import mutations from './customersMutations'
import actions from './customersActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
